import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteSpaceSlice = createSlice({
  name: 'DeleteSpace',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteSpace: (state, _) => {
      state.isLoading = true;
    },
    successDeleteSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteSpace: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSpace,
  failureDeleteSpace,
  successDeleteSpace,
  clearDeleteSpace,
} = DeleteSpaceSlice.actions;

export default DeleteSpaceSlice.reducer;
